import { render, staticRenderFns } from "./Tabbable.vue?vue&type=template&id=757aebe9&scoped=true"
import script from "./Tabbable.vue?vue&type=script&lang=ts"
export * from "./Tabbable.vue?vue&type=script&lang=ts"
import style0 from "./Tabbable.vue?vue&type=style&index=0&id=757aebe9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "757aebe9",
  null
  
)

export default component.exports